export enum Language {
  en = 'en',
  se = 'se'
}
